var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46213 0C9.25778 0 9.04989 0.0843659 8.87693 0.272687L5.16435 4.31134H2.58218C1.15597 4.31134 0 5.64294 0 7.28574V9.92913C0 11.5717 1.15619 12.9035 2.58218 12.9035H5.16435L8.87693 16.9422C9.05011 17.1305 9.25845 17.2149 9.46213 17.2149C9.9051 17.2149 10.3287 16.8169 10.3287 16.2216V0.993239C10.3287 0.398003 9.9051 0 9.46213 0ZM5.16435 12.0427H2.58218C2.14566 12.0427 1.72805 11.8386 1.40617 11.4682C1.05424 11.0628 0.860798 10.5166 0.860798 9.92913V7.28574C0.860798 6.69852 1.05424 6.15181 1.40617 5.74667C1.72805 5.37626 2.14566 5.17214 2.58218 5.17214H5.16435V12.043V12.0427Z",
    fill: "#F87E03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9023 5.16399V6.02479C12.3283 6.02479 13.4845 7.18098 13.4845 8.60696C13.4845 10.0329 12.3283 11.1891 10.9023 11.1891V12.0499C12.804 12.0499 14.3453 10.5084 14.3453 8.60696C14.3453 6.7055 12.8038 5.16399 10.9023 5.16399ZM10.9023 3.44238V4.30318C13.2795 4.30318 15.2061 6.2298 15.2061 8.60674C15.2061 10.9839 13.2795 12.9105 10.9023 12.9105V13.7713C13.7548 13.7713 16.0667 11.4592 16.0667 8.60696C16.0667 5.75477 13.7548 3.44261 10.9023 3.44261V3.44238ZM10.9023 6.88536V10.3283C11.8533 10.3283 12.6239 9.55747 12.6239 8.60674C12.6239 7.65623 11.8535 6.88536 10.9023 6.88536Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.51a9c3a9f32c883f112b7c14164d548e.svg";
export { ForwardRef as ReactComponent };